export default "__VITE_PUBLIC_ASSET__cb66d2ce__"